import React from 'react';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-[#040c14]/95 backdrop-blur-sm border-b border-[#152840]">
      <div className="max-w-7xl mx-auto px-3 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 overflow-hidden flex items-center justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_foxpress-creative/artifacts/dx75uml5_Augmented%20Cinematics.png" 
              alt="Augmented Cinematics Logo"
              className="h-10 w-auto"
              style={{ objectFit: 'cover', objectPosition: 'left center', marginLeft: '-8px' }}
            />
          </div>
          <div>
            <h1 className="text-base md:text-lg font-bold text-white leading-tight">Augmented Cinematics</h1>
            <p className="text-[10px] text-[#aaa] hidden sm:block">Harry Mann, Creative Director</p>
          </div>
        </div>
        
        {/* All links always visible - compact layout */}
        <nav className="flex items-center gap-1 sm:gap-2 md:gap-4 lg:gap-5">
          <button 
            onClick={() => scrollToSection('proof')}
            className="text-[#aaa] hover:text-white transition-colors duration-300 text-[10px] sm:text-xs md:text-sm px-1"
          >
            Services
          </button>
          <button 
            onClick={() => scrollToSection('spotlight')}
            className="text-[#aaa] hover:text-white transition-colors duration-300 text-[10px] sm:text-xs md:text-sm px-1"
          >
            Spotlight
          </button>
          <button 
            onClick={() => scrollToSection('framework')}
            className="text-[#aaa] hover:text-white transition-colors duration-300 text-[10px] sm:text-xs md:text-sm px-1"
          >
            Framework
          </button>
          <button 
            onClick={() => scrollToSection('library')}
            className="text-[#aaa] hover:text-white transition-colors duration-300 text-[10px] sm:text-xs md:text-sm px-1"
          >
            Gallery
          </button>
          <button 
            onClick={() => scrollToSection('tabor')}
            className="text-[#aaa] hover:text-white transition-colors duration-300 text-[10px] sm:text-xs md:text-sm px-1"
          >
            Tabor
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="text-[#aaa] hover:text-white transition-colors duration-300 text-[10px] sm:text-xs md:text-sm px-1"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="px-3 sm:px-4 md:px-5 py-1.5 bg-[#FF6500] hover:bg-[#E65A00] text-black font-medium rounded-full transition-all duration-300 text-[10px] sm:text-xs md:text-sm uppercase tracking-wider"
          >
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;